import { useState } from 'react';
import Modal from '../Common/Modal/Modal';
import PhoneIcon from '../icons/PhoneIcon';
import CopyIcon from '../icons/copyIcon';
import { useTranslation } from 'react-i18next';
import styles from './PhoneSupportModal.module.css';

const PhoneSupportModal = ({ open, onClose, phoneValue }) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  if (!phoneValue) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(phoneValue);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleCall = () => {
    window.location.href = `tel:${phoneValue}`;
  };

  return (
    <Modal open={open} onClose={onClose} animationClass='fade' hasBackground={true}>
      <div className={styles.modalContent}>
        <div className={`${styles.iconWrapper} mb-4`}>
          <div className={styles.iconCircle}>
            <PhoneIcon size='2rem' color='#0ea5e9' />
          </div>
        </div>

        <h3 className={`${styles.title}  font-1rem fw-semibold`}>
          {t('phoneSupport.description')}
        </h3>

        <div className={`${styles.phoneSection} mb-4`}>
          <div className={`${styles.phoneNumber} font-medium bold mb-3`}>{phoneValue}</div>
          <button
            onClick={handleCopy}
            className={`${styles.copyButton} ${copied ? styles.copied : ''}`}
            aria-label='Copy phone number'
          >
            <CopyIcon size='1.125rem' fillColor={copied ? '#10b981' : '#94a3b8'} />
            <span className='font-tiny '>{copied ? t('phoneSupport.copied') : 'Copiar'}</span>
          </button>
        </div>

        <button onClick={handleCall} className={`${styles.callButton} fw-semibold  font-1rem`}>
          <PhoneIcon size='1.25rem' color='#fff' />
          <span>{t('phoneSupport.callNow')}</span>
        </button>
      </div>
    </Modal>
  );
};

export default PhoneSupportModal;
